import saveAs from "file-saver";

export const base64ToBlob = (base64: string, type = "application/pdf") => {
  const byteArray = Uint8Array.from(
    atob(base64)
      .split("")
      .map((char) => char.charCodeAt(0)),
  );
  const blob = new Blob([byteArray], { type });
  return blob;
};

export const downloadPdf = (filename: string, base64: string) => {
  const blob = base64ToBlob(base64);
  saveAs(blob, filename);
};
